export function formatAmount(value, currency = "INR") {
  if (value === null || value === undefined || value === "") return "—";
  const num = typeof value === "number" ? value : Number(value);
  if (Number.isNaN(num)) return "—";
  const sym = currency === "USD" ? "$" : currency === "EUR" ? "€" : "₹";
  // Currency is always rendered with exactly 2 decimals visually
  // (e.g. 12.50, 37.50, 46.88). Stored numeric state is untouched —
  // this is a render-time affordance only.
  return `${sym}${num.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function shortDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
  } catch {
    return iso;
  }
}

export function bytes(n) {
  if (n === null || n === undefined) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

/**
 * Defensive text coercion for values that *should* be strings but might
 * leak through as objects from upstream error payloads (e.g. a backend
 * that nested another service's `{error, message}` body inside its own
 * `message` field). Renders without crashing React #31.
 *
 * Use anywhere a string from the backend lands directly in JSX.
 */
export function asText(v) {
  if (v === null || v === undefined) return "";
  if (typeof v === "string") return v;
  if (typeof v === "number" || typeof v === "boolean") return String(v);
  if (Array.isArray(v)) return v.map(asText).filter(Boolean).join("; ");
  if (typeof v === "object") {
    // Prefer human-readable fields in priority order. Recurse one level
    // in case e.g. `message` itself is a nested {error, message} dict.
    const pick = v.message ?? v.error ?? v.detail ?? v.error_message
                 ?? v.error_code ?? v.code;
    if (pick !== undefined) return asText(pick);
    try { return JSON.stringify(v); } catch { return String(v); }
  }
  return String(v);
}

